import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  props: {
    fieldKey: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    label: {
      type: Object, // localized string
      required: false,
    },
    options: {
      // form field specific options
      type: Object,
      required: false,
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onUpdate(value) {
      this.$emit("update", { fieldKey: this.fieldKey, value });
    },
    onOptionsUpdate(event) {
      this.onUpdate(event.target.value);
    },
    onInputUpdate(event) {
      this.onUpdate(event.target.value);
    },
    onTextareaUpdate(_, value) {
      // TODO: implement
    },
  },
};
